






import Vue from "vue";

export default Vue.extend({
    name: "GoHome",
    data() {
        return {};
    },
    methods: {
        goHome() {
            if (this.$route.path != "/") {
                this.$router.push("/");
            }
        }
    },
    computed: {
        showGoHome() {
            return window.history.length === 1 && this.$route.path != "/my" && this.$route.path != "/";
        }
    }
});
